import { h } from 'preact';
import { Text } from 'preact-i18n';
import { FinanceSpinner } from '../glyphs';
import { camel } from '../../lib/util';
import style from './style';

import Container from '../container';

const INTL_NS = 'company-profile';

export default function CompanyInfo({ data }) {
	let rows = data && data.rows && data.rows[0];

	if (!rows) {
		return (
			<FinanceSpinner />
		);
	}

	let { exchangeName, symbol, ceo, address, city, state, zipCode, phoneNumber, exchange, industry } = rows;
	let industryId = industry && industry.trim && industry.trim().length ? camel(industry) : 'dataUnavailable';

	return (
		<Container parent class={style.container} title={exchangeName || symbol}>
			<div class={style.left}>
				<DataWithLabel label={<Text id={`${INTL_NS}.ceo`} />} value={ceo} />
				<DataWithLabel value={address} unavailableTextId={`${INTL_NS}.addressUnavailable`} />
				{ city && state && zipCode &&
					<div>
						{`${city.toLowerCase()}, ${state} ${zipCode}`}
					</div>
				}
				<DataWithLabel
					value={!!phoneNumber && <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>}
					unavailableTextId={`${INTL_NS}.phoneNumberUnavailable`}
				/>
			</div>
			<div class={style.right}>
				<DataWithLabel label={<Text id={`${INTL_NS}.exchange`} />} value={exchange} lowercase={false} />
				<DataWithLabel label={<Text id={`${INTL_NS}.industry`} />} value={<Text id={`${INTL_NS}.industries.${industryId}`}>{industry}</Text>} />
			</div>
		</Container>
	);
}

export function DataWithLabel({ label, value, lowercase=true, unavailableTextId=`${INTL_NS}.dataUnavailable` }) {
	if (typeof value === 'string' && lowercase) value = value.toLowerCase();
	let labelValue = typeof label === 'object' ? label : label && `${label}`;
	return (
		<div >
			{label && labelValue}{label && ': '}<span class={value ? label && style.bold : style.dataUnavailable}>{value || <Text id={unavailableTextId} />}</span>
		</div>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/company-profile/company-info.js